import { Reveal } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Build the run",
    body: "Managers map out markets, drop pins, and assign crews with times, briefs, and gear lists — all from the dashboard.",
  },
  {
    n: "02",
    title: "Hit the street",
    body: "Reps open the app, check in on-site, follow the task list, and capture photo proof as they work the block.",
  },
  {
    n: "03",
    title: "Report in real time",
    body: "Samples, leads, and hours sync live. The moment a shift ends, clean data is ready for payroll and the client.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" data-testid="how-section" className="relative overflow-hidden bg-ink text-paper">
      <div className="pointer-events-none absolute inset-0 halftone-paper opacity-25" />
      <div className="relative mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-32">
        <Reveal className="mb-16">
          <p className="mb-3 font-mono text-xs uppercase tracking-[0.25em] text-orange">/ How it works</p>
          <h2 className="font-bebas text-5xl uppercase leading-[0.9] tracking-tight sm:text-6xl lg:text-7xl">
            Three steps from <span className="text-orange">brief</span> to <span className="text-outline">payroll</span>.
          </h2>
        </Reveal>

        <div className="space-y-0 border-t-2 border-paper/20">
          {STEPS.map((s, i) => (
            <Reveal
              key={s.n}
              delay={i * 0.06}
              className="group grid grid-cols-1 items-start gap-6 border-b-2 border-paper/20 py-10 md:grid-cols-12"
            >
              <div className="md:col-span-3">
                <span className="font-bebas text-7xl leading-none text-paper/25 transition-colors duration-300 group-hover:text-orange sm:text-8xl">
                  {s.n}
                </span>
              </div>
              <h3 className="font-bebas text-4xl uppercase leading-none tracking-tight md:col-span-4">
                {s.title}
              </h3>
              <p className="max-w-xl font-mono text-sm leading-relaxed text-paper/60 md:col-span-5">
                {s.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
